module.exports = __webpack_public_path__ + "img/TUSD-icon.1d7a8b62.svg";